import { ApiService } from '../../common'

export class AppTenantsApi extends ApiService {}
